<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="chevron-left">
<path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M17.0035 3.14669C17.1987 3.34195 17.1987 3.65854 17.0035 3.8538L8.85701 12.0002L17.0035 20.1467C17.1987 20.342 17.1987 20.6585 17.0035 20.8538C16.8082 21.0491 16.4916 21.0491 16.2963 20.8538L7.79635 12.3538C7.60109 12.1585 7.60109 11.842 7.79635 11.6467L16.2963 3.14669C16.4916 2.95143 16.8082 2.95143 17.0035 3.14669Z" fill="#212328"/>
</g>
</svg>
